@if (!loading) {
  <app-patient-header [patient]="patient" />
  <div class="page-container">
    <div class="mt-3">
      <div class="card">
        <div class="card-body">
          <h5 class="mb-4">Patient Prescriptions</h5>
          <app-pagination-header [paging]="paging" (pageSizeChange)="onPageSizeChange($event)" />
          <app-prescription-list
            [prescriptions]="prescriptions"
            [small]="true"
            [dark]="true"
            [fixedHeader]="true" />
          <app-pagination [paging]="paging" (pageChange)="onPageChange($event)" />
        </div>
      </div>
    </div>
  </div>
} @else {
  <mat-spinner />
}

